'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setThreadsSuccess = undefined;

var _reduxActions = require('redux-actions');

var _actionTypes = require('../constants/actionTypes');

var setThreadsSuccess = exports.setThreadsSuccess = (0, _reduxActions.createAction)(_actionTypes.SET_THREADS_SUCCESS);